<template>
  <IconLucideMessageSquarePlus />
</template>
